import { Fragment, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import axios from 'axios';
import { apiEndpoint } from './constants/api';
import { notify } from './components/Toast';
import SearchUsers from './components/planner/SearchUsers';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: {...state.user.currentEmployer}
}), {});
function Planner({ user, employer }) {

  const [plannerData, setPlannerData] = useState('');
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState([]);

  const onSubmit = (evt) => {
    evt.preventDefault();
  }

  const processPlan = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        apiEndpoint(`/ai/planner`), { 
          project: plannerData
        });
      setPlan(data);
      notify('Plan successfully created!');
      setLoading(false);
    } catch(ex){
      console.log('ex', ex);
    }
  };

  return (
    <>
    <Helmet>
      <title>Planner | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div>
                <div className="w-full mb-2 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
                  <div className="flex gap-4">
                    <div>
                      <div>
                        <h1 className="text-4xl text-gray-800">
                          Welcome to the Production Planner
                        </h1>
                      </div>
                      <div className="text-lg">Describe your upcoming project and we will give you recommendations.</div>
                    </div>
                    <div className="grow flex-col">
                      <div className="flex justify-end">
      
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-4">
                  <form onSubmit={onSubmit}>
                    <div className="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
                      <div className="px-4 py-2 bg-white rounded-t-lg dark:bg-gray-800">
                        <label htmlFor="comment" className="sr-only">Your comment</label>
                        <textarea value={plannerData} onChange={e => setPlannerData(e.target.value)} id="comment" rows="4" className="w-full px-0 text-lg text-gray-900 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400" placeholder="Outline your upcoming production requirements" required></textarea>
                         </div>
                         <div className="flex items-center justify-between px-3 py-2 border-t dark:border-gray-600">
                             <button disabled={loading} onClick={processPlan} type="submit" className="inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800">
                                 { loading ? <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                   <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                                   <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                   </svg> : <></>
                                 }
                                 { !loading ? 'Submit Plan' : 'Generating jobs' }
                             </button>
                         </div>
                     </div>
                  </form>
                  { plan.length ? <div>
                  <div className="py-2">We've identified jobs for your upcoming production and provided a searchable list of candidates</div>
                  <h3 className="text-4xl py-2 underline decoration-1 underline-offset-2">{ plan.length && plan[0].title }</h3>
                  { plan.length && plan[0].jobs.map(jobSection => {

                    return (<section id={`jobSection.name.replace(' ', '-')`} className="bg-white dark:bg-gray-900">
                      <div className="py-4 mx-auto max-w-screen-xl">
                          <div className="max-w-screen-lg text-gray-500 sm:text-lg dark:text-gray-400">
                              <h2 className="mb-4 text-4xl tracking-tight font-bold text-gray-900 dark:text-white">{jobSection.name}</h2>
                              <p className="mb-4 font-light">{jobSection.description}</p>
                              <SearchUsers skill={jobSection.name} />
                          </div>
                      </div>
                    </section>)
                  })}
                  </div>
                  : <></>}
                </div>
              </div>
              {/* /End replace */}
            </div>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(Planner);
